export default __webpack_public_path__ + "dist/media/PlusDarkBlue.6209ff4a.svg";